import { render } from "./PurchaseReserve.vue?vue&type=template&id=689abe2d&scoped=true&ts=true&lang=pug"
import script from "./PurchaseReserve.vue?vue&type=script&lang=ts"
export * from "./PurchaseReserve.vue?vue&type=script&lang=ts"

import "./PurchaseReserve.vue?vue&type=style&index=0&id=689abe2d&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-689abe2d"]])

export default __exports__